<template>
  <section class="section auto bg-light" id="ourService">
    <SectionTitle :title="$t('main.ourService.title')" :summary="$t('main.ourService.summary')" />
    <div class="section-contents" data-aos="fade-up" data-aos-delay="500">
      <div class="service-button-list">
        <!-- 서비스 -->
        <router-link to="/service" :key="'service-' + $route.fullPath" class="service-big-btn service">
          <div class="service-btn-overlay"></div>
          <div class="service-btn-content">
            <ContentsTitle :title="$t('menu.service')" :summary="$t('service.desc.01')" />
            <div class="tag">
              <span class="item">{{ $t('service.title.keycloak') }}</span>
              <span class="item">{{ $t('service.title.aiData') }}</span>
              <span class="item">{{ $t('service.title.cloud') }}</span>
              <span class="item">{{ $t('service.title.maintenance') }}</span>
            </div>
            <span class="service-btn-more">{{ $t('more') }} →</span>
          </div>
        </router-link>

        <!-- 솔루션 -->
        <router-link to="/solution" :key="'solution-' + $route.fullPath" class="service-big-btn solution">
          <div class="service-btn-overlay"></div>
          <div class="service-btn-content">
            <ContentsTitle :title="$t('menu.solution')" :summary="$t('solution.desc.01')" />
            <div class="tag">
              <span class="item">{{ $t('solution.title.nsddh') }}</span>
              <span class="item">{{ $t('solution.title.iam') }}</span>
              <span class="item">{{ $t('solution.title.sso') }}</span>
              <span class="item">{{ $t('solution.title.twoFactor') }}</span>
            </div>
            <span class="service-btn-more">{{ $t('more') }} →</span>
          </div>
        </router-link>

        <!-- 컨설팅 -->
        <router-link to="/consulting" :key="'consulting-' + $route.fullPath" class="service-big-btn consulting">
          <div class="service-btn-overlay"></div>
          <div class="service-btn-content">
            <ContentsTitle :title="$t('menu.consulting')" :summary="$t('consulting.desc.01')" />
            <div class="tag">
              <span class="item">{{ $t('consulting.title.operation') }}</span>
              <span class="item">{{ $t('consulting.title.client') }}</span>
              <span class="item">{{ $t('consulting.title.server') }}</span>
              <span class="item">{{ $t('consulting.title.monitoring') }}</span>
              <span class="item">{{ $t('consulting.title.member') }}</span>
            </div>
            <span class="service-btn-more">{{ $t('more') }} →</span>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'
import ContentsTitle from '@/components/ContentsTitle'

export default {
  name: 'OurService',
  components: { ContentsTitle, SectionTitle }
}
</script>

<style scoped>
</style>
